import React from 'react';
import moment from 'moment';

import http from 'api/http';
import { boatAPI, trailerAPI, componentAPI, manufacturerAPI } from 'api/requests';

import { consoleWarninig } from 'utils';

import { downloadFile } from 'helpers';

import Select, { selectType } from 'Components/Select';
import ApplicationActions from 'Components/ApplicationActions';
import MMLReport from './MMLReport';
import HistoricMMLReport from './HistoricMMLReport';
import CARBReport from './CARBReport';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import NotificationManager from 'dom-managers/notification';
import { ROLES } from 'constants/roles';
import ComponentList from './ComponentList';

export default class ReportScene extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedReport: {},
      reportSubType: '',
      inputErrors: {},
      reportYear: '',
      contact: null,
      reportDate: '',
      selectedBoatsList: [],
      isModalOpen: false,
      modalRequestInProcess: false,
      downloadRequestInProcess: false,
      tagType: 'Mylar',
      PO:'',
      RUSH:'',
      selectedTypesList:[],
    };

    this.requiredFields = [];
    this.requiredBoatListFields = [];
    this.currentModelYear = new Date().getFullYear();

    this.yearsList = [];
    this.contactsList =[];
    this.modalBody = '';

    this.reportTypes = this._initReportTypes();
    this.api = this._initAPI();
  }

  componentDidMount() {
    const { user } = this.props;
    const code = user.selectedManufacturer.code;

    if (this.api.currentModelYear) {
      http.get(this.api.currentModelYear)
        .then(({data: currentModelYear}) => {
          this.currentModelYear = currentModelYear.length ? +(currentModelYear[1] || currentModelYear[0]) : +currentModelYear;
          for (let i = +this.currentModelYear + 1; i > this.currentModelYear - 20; i--) this.yearsList.push(i);
        });
    }

    http
      .get(manufacturerAPI.getEngineeringContacts(code))
      .then(response => {
        this.contactsList = response.data;
        var c = response.data[0];
        this.setState({
          contact: c
        })
      })
      .catch(() => {
        this.setState({ contact: null });
        this.contactsList =[]
      });

    if (this.reportTypes.length === 1) this.handleReportTypeSelect(this.reportTypes[0])
  }

  _initReportTypes = () => {
    const {user} = this.props;

    const reportTypes = [];

    if (!user.isInspector() && (user.getActiveRole() === ROLES.TRAILER_MANUFACTURER.serverName || user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName)) {
      reportTypes.push({
        name: 'Master Model List',
        type: 'MML',
        requiredFields: ['reportYear', 'contact'],
        actionButtonLabel: 'E-Sign',
        actionConfirmMessage: 'Are you sure you want to generate and e-sign the Master Model List?'
      });
    }

    if (user.getActiveRole() === ROLES.TRAILER_MANUFACTURER.serverName || user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName) {
      reportTypes.push({
        name: 'Historic Master Model List',
        type: 'HistoricMML',
        requiredFields: ['reportYear', 'reportDate'],
        actionButtonLabel: 'Download',
        actionConfirmMessage: 'Are you sure you want to generate and e-sign the Master Model List?'
      });
    }

    if (user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName) {
      reportTypes.push({
        name: 'Capacity tag',
        type: 'CARB',
        requiredFields: ['reportYear', 'reportSubType', 'tagType', 'selectedBoatsList'],
        requiredBoatListFields: ['qty'],
        additionalRequiredFieldsByReportSubType: {
          'CARB': {requiredFields: [], requiredBoatListFields: ['EVAPFamily', 'emission']}
        },
        actionButtonLabel: 'Download',
        actionConfirmMessage: ''
      });
    }

    if (user.getActiveRole() === ROLES.COMPONENT_MANUFACTURER.serverName) {
      reportTypes.push({
        name: 'List report',
        type: 'ComponentList',
        requiredFields: ['selectedTypesList'],
        additionalRequiredFieldsByReportSubType: {},
        actionButtonLabel: 'Download',
        actionConfirmMessage: ''
      });
    }

    return reportTypes;
  };

  _initAPI = () => {
    const {user} = this.props;

    if (user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName) {
      return boatAPI;
    } else if (user.getActiveRole() === ROLES.TRAILER_MANUFACTURER.serverName) {
      return trailerAPI;
    } else if (user.getActiveRole() === ROLES.COMPONENT_MANUFACTURER.serverName) {
      return componentAPI;
    }
  };

  handleReportTypeSelect = selectedReport => {
    const {user} = this.props;
    const {selectedBoatsList} = this.state;

    this.modalBody = 'If you change this setting, all previously added data will be deleted';
    this.modalConfirmAction = () => {
      this.requiredFields = [...selectedReport.requiredFields];
      this.requiredBoatListFields = selectedReport.requiredBoatListFields ? [...selectedReport.requiredBoatListFields] : [];
      this.setState({
        reportSubType: '',
        inputErrors: {},
        reportYear: '',
        //contact: '',
        reportDate: '',
        selectedBoatsList: [],
        isModalOpen: false,
        modalRequestInProcess: false,
        downloadRequestInProcess: false,
        tagType: 'Mylar',
        PO:'',
        RUSH:'',
        selectedTypesList:[],
        selectedReport}, () => this.handleYearSelect(user.getSelectedYear() || this.currentModelYear));
    };

    if (!selectedBoatsList.length) this.modalConfirmAction();
    else this.setState({isModalOpen: true});
  };

  handleReportSubTypeSelect = type => {
    const {selectedBoatsList, selectedReport} = this.state;

    this.modalBody = 'If you change this setting, all previously added data will be deleted';
    this.modalConfirmAction = () => {
      this.setState({reportSubType: type, inputErrors: {}, isModalOpen: false, selectedBoatsList: []}, () => {
        const additionalFieldsLists = selectedReport.additionalRequiredFieldsByReportSubType[type];
        if (additionalFieldsLists) {
          this.requiredFields = [...selectedReport.requiredFields, ...additionalFieldsLists.requiredFields];
          this.requiredBoatListFields = (selectedReport.requiredBoatListFields && additionalFieldsLists.requiredBoatListFields) ?
            [...selectedReport.requiredBoatListFields, ...additionalFieldsLists.requiredBoatListFields] : [];
        } else {
          this.requiredFields = [...selectedReport.requiredFields];
          this.requiredBoatListFields = selectedReport.requiredBoatListFields ? [...selectedReport.requiredBoatListFields] : [];
        }
      });
    };

    if (!selectedBoatsList.length) this.modalConfirmAction();
    else this.setState({isModalOpen: true});
  };

  handleYearSelect = inputYear => {
    const {user} = this.props;
    const {inputErrors, selectedBoatsList, reportYear} = this.state;

    if (inputYear !== reportYear) {
      delete inputErrors.reportYear;
      user.saveSelectedYear(inputYear);

      this.modalBody = 'If you change this setting, all previously added data will be deleted';
      this.modalConfirmAction = () => {
        this.setState({reportYear: inputYear, inputErrors, isModalOpen: false, selectedBoatsList: []});
      };

      if (!selectedBoatsList.length) this.modalConfirmAction();
      else this.setState({isModalOpen: true});
    }
  };

  handleContactSelect = input => {
    const {inputErrors, contact} = this.state;
    let newInputErrors = inputErrors;
    const selectedItem = input.value || input;

    delete newInputErrors.contact;
    this.setState({contact: selectedItem, inputErrors: newInputErrors});
  };

  handleDateChoose = (utcDate, error) => {
    const {inputErrors, selectedReport} = this.state;

    delete inputErrors.reportDate;

    if (error) inputErrors.reportDate = 'Provide valid date, or completely delete it';
    else if (selectedReport.type === 'HistoricMML' && utcDate > moment().utc()) inputErrors.reportDate = 'Unable to provide historic report for future date';
    this.setState({reportDate: utcDate, inputErrors});
  };

  handleTagTypeSelect = tag => {
    const {selectedBoatsList, inputErrors} = this.state;

    let newInputErrors = inputErrors;
    delete newInputErrors.tagType;

    this.modalBody = 'If you change this setting, all previously added data will be deleted';
    this.modalConfirmAction = () => {
      this.setState({
        tagType: tag,
        inputErrors: newInputErrors,
        isModalOpen: false,
        selectedBoatsList: []
      });
    };

    if (!selectedBoatsList.length) this.modalConfirmAction();
    else this.setState({isModalOpen: true});
  };

  handleSelect = fieldName => input => {
    const {inputErrors} = this.state;
    let newInputErrors = inputErrors;
    const selectedItem = input.value || input;

    delete newInputErrors[fieldName];
    this.setState({[fieldName]: selectedItem, inputErrors: newInputErrors});
  };

  closeModal = () => {
    this.setState({modalRequestInProcess: false, isModalOpen: false});
  };

  handleInputChange = field => (value, error) => {
    const {inputErrors} = this.state;
    if (!error || error.ops) {
      let newInputErrors = inputErrors;
      delete newInputErrors[field];
      this.setState({[field]: value, inputErrors: newInputErrors});
    }
  };

  handleToggleValue = field => () => {
    this.setState(prevState => {return {[field]: !prevState[field]};});
  };

  addBoat = boat => {
    const {inputErrors} = this.state;
    let newInputErrors = inputErrors;
    delete newInputErrors.selectedBoatsList;

    let newSelectedBoatsList = this.state.selectedBoatsList;
    newSelectedBoatsList.push(boat);
    this.setState({selectedBoatsList: newSelectedBoatsList, inputErrors: newInputErrors});
  };

  removeBoat = index => () => {
    let newSelectedBoatsList = this.state.selectedBoatsList;
    newSelectedBoatsList.splice(index, 1);
    this.setState({selectedBoatsList: newSelectedBoatsList});
  };

  handleBoatParamChange = (boatId, index, param) => value => {
    const {selectedBoatsList, inputErrors} = this.state;
    let newSelectedBoatsList = selectedBoatsList;
    let newInputErrors = inputErrors;
    if (newInputErrors.boatsListErrors && newInputErrors.boatsListErrors[boatId]) {
      delete newInputErrors.boatsListErrors[boatId][param];
      if (!Object.keys(newInputErrors.boatsListErrors[boatId]).length) delete newInputErrors.boatsListErrors[boatId];
      if (!Object.keys(newInputErrors.boatsListErrors).length) delete newInputErrors.boatsListErrors;
    }
    newSelectedBoatsList[index][param] = value;
    this.setState({selectedBoatsList: newSelectedBoatsList, inputErrors: newInputErrors});
  };

  addComponentTypeId = typeId => {
    let {selectedTypesList, inputErrors} = this.state;
    selectedTypesList.push(typeId);
    delete inputErrors.selectedTypesList;
    this.setState({selectedTypesList});
  };

  removeComponentTypeId = typeId => {
    let {selectedTypesList} = this.state;
    const typeIndex = selectedTypesList.indexOf(typeId);
    if (typeIndex !== -1) selectedTypesList.splice(typeIndex, 1);
    this.setState({selectedTypesList});
  };

  clearComponentTypeIds = () => {
    this.setState({selectedTypesList:[]});
  };

  normalizePlateType = plateType => {
    if (!plateType) return plateType;

    const stringifiedPlateType = plateType.toString();
    return stringifiedPlateType.includes('PLATE_TYPE_') ? stringifiedPlateType : `PLATE_TYPE_${stringifiedPlateType}`;
  };

  getReportFilters = () => {
    const {selectedReport, inputErrors, reportYear, contact, reportDate, selectedBoatsList, reportSubType, tagType, RUSH, PO,
      selectedTypesList} = this.state;
    switch (selectedReport.type) {
      case 'MML':
        return (
          <MMLReport
            inputErrors={inputErrors}
            handleSelect={this.handleSelect}
            handleYearSelect={this.handleYearSelect}
            handleContactSelect={this.handleContactSelect}
            yearsList={this.yearsList}
            contactsList={this.contactsList}
            reportYear={reportYear}
            contact={contact}
          />
        );
      case 'HistoricMML':
        return (
          <HistoricMMLReport
            inputErrors={inputErrors}
            handleSelect={this.handleSelect}
            handleYearSelect={this.handleYearSelect}
            yearsList={this.yearsList}
            reportYear={reportYear}
            reportDate={reportDate}
            handleDateChoose={this.handleDateChoose}
          />
        );
      case 'CARB':
        return (
          <CARBReport
            inputErrors={inputErrors}
            handleSelect={this.handleSelect}
            handleYearSelect={this.handleYearSelect}
            yearsList={this.yearsList}
            handleTagTypeSelect={this.handleTagTypeSelect}
            handleReportSubTypeSelect={this.handleReportSubTypeSelect}
            handleDateChoose={this.handleDateChoose}
            handleInputChange={this.handleInputChange}
            handleToggleValue={this.handleToggleValue}
            reportSubType={reportSubType}
            tagType={tagType}
            reportYear={reportYear}
            RUSH={RUSH}
            PO={PO}
            reportDate={reportDate}
            addBoat={this.addBoat}
            removeBoat={this.removeBoat}
            selectedBoatsList={selectedBoatsList}
            handleBoatParamChange={this.handleBoatParamChange}
          />
        );
      case 'ComponentList':
        return (
          <ComponentList
            inputErrors={inputErrors}
            addComponentTypeId={this.addComponentTypeId}
            removeComponentTypeId={this.removeComponentTypeId}
            selectedTypesList={selectedTypesList}
            clearComponentTypeIds={this.clearComponentTypeIds}
          />
        );
      default:
        return null;
    }
  };

  validateForm = () => {
    const {selectedReport, inputErrors, selectedBoatsList} = this.state;
    let newInputErrors = inputErrors;

    if (!selectedReport.type) newInputErrors.selectedReport = 'Please choose report type';
    else {
      this.requiredFields.forEach((fieldname) => {
        let fieldToCheck = this.state[fieldname];
        if (!fieldToCheck || (Array.isArray(fieldToCheck) && !fieldToCheck.length)) newInputErrors[fieldname] = true;
      });
      if (this.requiredBoatListFields.length) {
        selectedBoatsList.forEach(boat => {
          this.requiredBoatListFields.forEach(fieldName => {
            if (!boat[fieldName]) {
              if (!newInputErrors.boatsListErrors) newInputErrors.boatsListErrors = {};
              if (!newInputErrors.boatsListErrors[boat.id]) newInputErrors.boatsListErrors[boat.id] = {};
              newInputErrors.boatsListErrors[boat.id][fieldName] = true;
              if (fieldName === 'qty') NotificationManager.error('note', 'Please enter quantity for every boat in a list');
            }
          });
        });
      }
    }
    return new Promise((resolve, reject) => {this.setState({inputErrors: newInputErrors}, () => {if (Object.keys(this.state.inputErrors).length) reject(); else resolve();});});
  };

  downloadOrSignReport = () => {
    const {selectedReport, reportYear, contact, reportSubType, RUSH, PO, tagType, selectedBoatsList,
      reportDate, selectedTypesList} = this.state;
    const {user} = this.props;

    this.validateForm()
      .then(() => {
        let name = '';
        switch (selectedReport.type) {
          case 'MML':
            this.modalBody = selectedReport.actionConfirmMessage;
            this.modalConfirmAction = () => {
              this.setState({modalRequestInProcess: true});
              http.get(this.api.getMMLReport(reportYear, encodeURIComponent(contact.email)), {responseType: 'blob'})
                .then(() => NotificationManager.success(1, 'Master Model List has been successfully generated and sent for e-signature to DocuSign.'))
                .finally(this.closeModal);
            };
            this.setState({isModalOpen: true});
            break;
          case 'HistoricMML':
            name = `Historic_MML_${reportDate.format('YYYY-MM-DD')}_${user.getManufacturerName()}.pdf`;
            this.setState({downloadRequestInProcess: true}, ()=> {
              const dateString = reportDate.utc().format('YYYY-MM-DD');
              http.get(this.api.getHistoricMMLReport(reportYear, dateString), {responseType: 'blob'})
                .then(({data}) => {
                  downloadFile(data, name);
                })
                .finally(() => {
                  this.setState({downloadRequestInProcess: false});
                })
            });
            break;
          case 'CARB': {
            name = `${reportSubType.toUpperCase()}_${reportYear}_${user.getManufacturerName()}.xlsx`;
            let dataPayload = {
              'capacityTagReportType': reportSubType.toUpperCase(),
              'deliveryDate': reportDate.isValid && reportDate.isValid() ? reportDate.utc() : null,
              'isRush': !!RUSH,
              'modelYear': reportYear,
              'poNumber': !PO ? null : PO,
              'tagType': tagType.toUpperCase()
            };
            dataPayload.boatReportRequests = selectedBoatsList.map(boat => {
              return ({
                'boatId': boat.id,
                'californiaEVAPFamily': boat.EVAPFamily,
                'emissionControlSystem': boat.emission,
                'plateType': this.normalizePlateType(boat.plateType),
                'quantity': boat.qty
              });
            });
            this.setState({downloadRequestInProcess: true}, () => {
              http.post(this.api.getCARBReport, dataPayload, {responseType: 'blob'})
                .then(({data}) => {
                  downloadFile(data, name);
                })
                .finally(() => {
                  this.setState({selectedBoatsList:[]}, () => {
                    this.handleReportTypeSelect(this.reportTypes[2])
                  });
                })
            });
            break;
          }
          case 'ComponentList': {
            name = `ComponentList_${user.getManufacturerName()}.pdf`;
            this.setState({downloadRequestInProcess: true}, () => {
              http.get(componentAPI.listReport(selectedTypesList), {responseType: 'blob'})
                .then(({data}) => {
                  downloadFile(data, name);
                })
                .finally(() => {
                  this.setState({downloadRequestInProcess: false});
                })
            });
            break;
          }
          default:
            consoleWarninig(`Attempted to download unknown report of ${selectedReport.type} type`);
        }
      });
  };

  render() {
    const {selectedReport, inputErrors, isModalOpen, modalRequestInProcess, downloadRequestInProcess} = this.state;

    return (
      <main className='scene-wrapper'>
        <section className='application-scene'>
          <header>Reports</header>
          <section className='report-type-choose-section'>
            <header>Report</header>
            <Select
              selectionList={this.reportTypes}
              defaultItem={selectedReport}
              type={selectType.primary}
              dropDownClassName='_top_51'
              withoutSearch
              placeholder='Please select report…'
              itemNameIndicator='name'
              error={inputErrors.selectedReport}
              handleSelect={this.handleReportTypeSelect}
            />
          </section>
          {selectedReport.type && this.getReportFilters()}
          {selectedReport.type && (
            <ApplicationActions
              saveButtonLabel={selectedReport.actionButtonLabel}
              disableSaveButton={downloadRequestInProcess}
              saveButtonAction={this.downloadOrSignReport}
            />
          )}
        </section>
        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this.closeModal}
            />
            <Button
              label='Yes'
              buttonClassName='_height_40 _width_160'
              disabledWithSpinner={modalRequestInProcess}
              onClick={this.modalConfirmAction}
            />
          </footer>
        </Modal>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/index.jsx